import React from "react";
import {FormComponent} from "../../components/FormComponent";
import {Loader} from "../../components/Loader";
import {FormSubmit} from "../../components/FormComponent/FormSubmit";
import {FormGroup} from "../../components/FormComponent/FormGroup";

export class SettingsLanguage extends FormComponent {

    componentDidMount() {
        let [namespace, key] = this.getParams();

        this.request.fetch('/settings/get', {key: key, namespace: namespace})
            .then((values: any) => {

                this.setState({
                    'dictionaryLanguages': values.elem['dictionary.languages'],
                    'dictionaryVersion': values.elem['dictionary.version'],
                    'handledLanguages': values.elem['handled.languages'],
                });

            }).catch(error => {
            this.onError(error);
        });
    }

    protected onSuccess(data: any, event: React.FormEvent | null): any {
        (document.querySelector('form .alert.alert-success') as HTMLElement).classList.remove('hide');
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        return (
            <>
                <form className="x-form" action="/settings/save" onSubmit={this.handleSubmit}>

                    <div className="row justify-content-center">

                        <div className="col-md-12 col-lg-10 col-xl-8 col-xxl-6">
                            <br/>&nbsp;
                            <h5>
                                {this.dictionary.get['language-settings']}
                            </h5>
                            <FormGroup.Info>{this.dictionary.get['effect-after-60-sec']}</FormGroup.Info>

                            <FormGroup.Input {...{
                                id: 'dictionary.languages',
                                label: 'available-languages',
                                required: true,
                                help: 'lang-s-help',
                                defaultValue: this.state.dictionaryLanguages
                            }}/>

                            <FormGroup.Input {...{
                                id: 'handled.languages',
                                label: 'handled-languages',
                                required: true,
                                help: 'handled-lang-s-help',
                                defaultValue: this.state.handledLanguages
                            }}/>

                            <FormGroup.Input {...{
                                id: 'dictionary.version',
                                disabled: true,
                                help: 'dictionary-version-help',
                                defaultValue: this.state.dictionaryVersion
                            }}/>

                            <FormSubmit/>
                        </div>
                    </div>
                </form>

            </>
        );
    }
}